const routes = [
  {
    path: 'jslist',
    name: 'jslist',
    component: () => import(/* webpackChunkName: "jslist" */ '@/modules/jslist/index.vue')
  },
];

export default routes;